import { f as focusVisiblePolyfill, h as handleFirstTab } from "./accessibility-295f1f93.js";
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
window.addEventListener("keydown", handleFirstTab);
class ValidatedForm extends HTMLFormElement {
  constructor() {
    super();
    this.setupValidation();
  }
  setupValidation() {
    this.addEventListener("submit", (e) => {
      e.preventDefault();
      this.validateForm();
    });
    const inputs = this.querySelectorAll("input, select, textarea");
    inputs.forEach((input) => {
      input.addEventListener("focus", () => {
        input.classList.add("active");
        input.classList.remove("inactive");
      });
      input.addEventListener("blur", () => {
        if (!input.value) {
          input.classList.remove("active");
          input.classList.add("inactive");
        }
      });
      input.addEventListener("input", () => {
        this.clearError(input);
        if (input.value) {
          input.classList.add("active");
          input.classList.remove("inactive");
        } else {
          input.classList.remove("active");
          input.classList.add("inactive");
        }
      });
      input.addEventListener("invalid", (e) => {
        this.addError(input);
      });
    });
  }
  validateForm() {
    const inputs = this.querySelectorAll("input, select, textarea");
    inputs.forEach((input) => this.clearError(input));
    const requiredFields = this.querySelectorAll("[required]");
    requiredFields.forEach((field) => {
      if (!field.value.trim() || !field.checkValidity()) {
        this.addError(field);
      }
    });
  }
  addError(field) {
    field.classList.add("error");
    field.classList.remove("active");
    field.classList.remove("inactive");
  }
  clearError(field) {
    field.classList.remove("error");
  }
}
customElements.define("validated-form", ValidatedForm, { extends: "form" });
document.querySelectorAll('.form-input-wrapper input[type="text"], .form-input-wrapper input[type="email"], .form-input-wrapper input:not([type])').forEach((input) => {
  const wrapper = input.closest(".form-input-wrapper");
  if (!wrapper)
    return;
  const checkOverflow = () => {
    if (input.scrollWidth > input.clientWidth) {
      wrapper.classList.add("is-overflowing");
    } else {
      wrapper.classList.remove("is-overflowing");
    }
  };
  input.addEventListener("input", checkOverflow);
  window.addEventListener("load", checkOverflow);
});
